import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { ICompanies } from 'search/classes/models/ICompanies'
import { ICompanyInfo } from 'search/classes/models/ICompanyInfo'
import { IFetchResult } from 'src/core/classes/helpers/store/Interfaces'
import { HttpCancel } from 'src/core/classes/http'
import { CrudHelper } from 'src/core/types/helpers/CrudHelper'

export const fetchStory = async (
  pid: string,
  cancelObject: HttpCancel
): Promise<IFetchResult<ICompanies>> => {
  const crudHelper = new CrudHelper(494, 'Companies Search - Company Info')
  const filter: IDataProviderFilter | IObjectAny = {
    logic: Logic.AND,
    filters: [
      {
        field: 'PID',
        operator: Operator.EQUAL,
        value: pid,
      },
    ],
  }
  const crudResult = await crudHelper.read(filter, undefined, undefined, 20, cancelObject)
  return {
    items: (crudResult && crudResult['Data']) || [],
    total: crudResult['Total'] || (crudResult['Data'] && crudResult['Data'].length) || 0,
  }
}

export const fetchCompanies = async (
  query: string,
  pid: string,
  cancelObject: HttpCancel
): Promise<IFetchResult<ICompanies>> => {
  const crudHelper = new CrudHelper(492, 'Companies Search - queries')
  const filter: IDataProviderFilter | IObjectAny = {
    logic: Logic.AND,
    filters: [
      {
        field: 'SearchString',
        operator: Operator.EQUAL,
        value: query,
      },
      {
        field: 'PID',
        operator: Operator.EQUAL,
        value: pid,
      },
    ],
  }
  const crudResult = await crudHelper.read(filter, undefined, undefined, undefined, cancelObject)
  return {
    items: (crudResult && crudResult['Data']) || [],
    total: crudResult['Total'] || (crudResult['Data'] && crudResult['Data'].length) || 0,
  }
}

export const setCompanies = async (
  data: any,
  cancelObject: HttpCancel
): Promise<IFetchResult<ICompanies>> => {
  const crudHelper = new CrudHelper(492, 'Companies Search - queries')
  const crudResult = await crudHelper.create([data], cancelObject)
  return {
    items: crudResult || [],
    total: crudResult.length || 0,
  }
}

export const fetchCompanyInfo = async (
  placeId: string,
  pid: string,
  cancelObject: HttpCancel
): Promise<IFetchResult<ICompanyInfo>> => {
  const crudHelper = new CrudHelper(494, 'Companies Search - Company Info')
  const filter: IDataProviderFilter | IObjectAny = {
    logic: Logic.AND,
    filters: [
      {
        field: 'PlaceId',
        operator: Operator.EQUAL,
        value: placeId,
      },
      {
        field: 'PID',
        operator: Operator.EQUAL,
        value: pid,
      },
    ],
  }
  const crudResult = await crudHelper.read(filter, undefined, undefined, undefined, cancelObject)
  return {
    items: (crudResult && crudResult['Data']) || [],
    total: crudResult['Total'] || (crudResult['Data'] && crudResult['Data'].length) || 0,
  }
}

export const setCompanyInfo = async (
  data: any,
  cancelObject: HttpCancel
): Promise<IFetchResult<ICompanyInfo>> => {
  const crudHelper = new CrudHelper(494, 'Companies Search - Company Info')
  const crudResult = await crudHelper.create([data], cancelObject)
  return {
    items: crudResult || [],
    total: crudResult.length || 0,
  }
}
